import { axiosWithAuth } from "../../helpers";

export const asyncValidationService = {
	isMidUnique,
	checkIsDiscoverMidUnique,
	validateOriginalMid,
	webSiteCheck,
	checkStraddleIdentifier,
	checkIfEmailUnique,
};

const API_URL = process.env.REACT_APP_API_URL;

function isMidUnique(mid, merchantId) {
	const options = {
		method: "GET",
		params: { mid, merchantId },
		url: `${API_URL}/api/merchants/check-if-exists`,
	};

	return axiosWithAuth(options);
}

function checkIsDiscoverMidUnique(discoverMid) {
	const options = {
		method: "GET",
		params: { discoveryMID: discoverMid },
		url: `${API_URL}/api/merchants/check_if_discovery_mid_exists`,
	};

	return axiosWithAuth(options);
}

function validateOriginalMid(originalMID, merchantId) {
	const options = {
		method: "GET",
		params: { originalMID, merchantId },
		url: `${API_URL}/api/validate/original-mid`,
	};

	return axiosWithAuth(options);
}

function webSiteCheck(webSiteUrl) {
	const options = {
		method: "GET",
		params: { webSiteUrl },
		url: `${API_URL}/api/application/webSiteCheck`,
	};

	return axiosWithAuth(options);
}

function checkStraddleIdentifier(straddleIdentifier) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/ach/is_straddle_identifier_exists/${straddleIdentifier}`,
	};

	return axiosWithAuth(options);
}

function checkIfEmailUnique(email) {
	const options = {
		method: "GET",
		params: { email },
		url: `${API_URL}/api/user_emails/check_if_exists`,
	};

	return axiosWithAuth(options);
}
